const PUBLIC_PATHS: string[] = ["/claim", "/support"];
export const isPublicPath = (pathname: string) =>
  PUBLIC_PATHS.some((p) => pathname === p || pathname.startsWith(p + "/"));
